import { palette } from '@livable/saas-react-components';
const MuiSvgIcon = {
  styleOverrides: {
    root: {
      verticalAlign: 'middle',
      path: {
        transition: "fill ".concat(palette.transitions.short)
      }
    },
    fontSizeSmall: {
      fontSize: '18px'
    },
    fontSizeLarge: {
      fontSize: '32px'
    },
    fontSizeXLarge: {
      fontSize: '48px'
    },
    fontSizeHuge: {
      fontSize: '40px'
    },
    colorSuccess: {
      path: {
        fill: palette.success.main
      }
    }
  },
  variants: [{
    props: {
      type: 'static'
    },
    style: {
      display: 'inline-block',
      padding: '12px',
      backgroundColor: palette.shades[200],
      borderRadius: '2px',
      width: '48px',
      height: '48px',
      '& path': {
        fill: palette.shades[700]
      },
      '& + &': {
        marginLeft: '10px'
      }
    }
  }, {
    props: {
      type: 'tabClose'
    },
    style: {
      '& path': {
        fill: "".concat(palette.shades[700], " !important ")
      }
    }
  }, {
    props: {
      color: 'error'
    },
    style: {
      backgroundColor: palette.error.light,
      borderRadius: '2px',
      path: {
        fill: palette.error.main
      }
    }
  }, {
    props: {
      color: 'success'
    },
    style: {
      backgroundColor: palette.success.light,
      borderRadius: '2px',
      path: {
        fill: palette.success.main
      }
    }
  }, {
    props: {
      color: 'success-bold'
    },
    style: {
      backgroundColor: palette.success.main,
      borderRadius: '2px',
      path: {
        fill: palette.shades[100]
      }
    }
  }, {
    props: {
      color: 'grey'
    },
    style: {
      backgroundColor: palette.shades[300],
      borderRadius: '2px',
      path: {
        fill: palette.shades[600]
      }
    }
  }, {
    props: {
      color: 'info'
    },
    style: {
      backgroundColor: palette.info.light,
      borderRadius: '2px',
      path: {
        fill: palette.info.main
      }
    }
  }, {
    props: {
      color: 'warning'
    },
    style: {
      backgroundColor: palette.warning.light,
      borderRadius: '2px',
      path: {
        fill: palette.warning.main
      }
    }
  }, {
    props: {
      state: 'error'
    },
    style: {
      path: {
        fill: palette.error.main
      }
    }
  }, {
    props: {
      state: 'success'
    },
    style: {
      path: {
        fill: palette.success.main
      }
    }
  }, {
    props: {
      state: 'primary'
    },
    style: {
      path: {
        fill: palette.primary.main
      }
    }
  }, {
    props: {
      state: 'info'
    },
    style: {
      path: {
        fill: palette.info.main
      }
    }
  }, {
    props: {
      state: 'warning'
    },
    style: {
      path: {
        fill: palette.warning.main
      }
    }
  }, {
    props: {
      state: 'dark'
    },
    style: {
      path: {
        fill: palette.primary.dark
      }
    }
  }, {
    props: {
      state: 'grey'
    },
    style: {
      path: {
        fill: palette.shades[600]
      }
    }
  }, {
    props: {
      state: 'lightGrey'
    },
    style: {
      path: {
        fill: palette.shades[500]
      }
    }
  }]
};
export default MuiSvgIcon;